import api from '../../services/api';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";
import { useGetVendorId } from "../global/User";



const empty = {
    type: "PRIZE_GAME",
    title: "",
    description: "",
    enabled: true,
    end_date: null,
    start_date: null,
    gdpr_promotions: "",
    participation_notification_settings: "",
    participation_requirements: "",
    profile_id: null,
    registered_users: "",
    terms_and_conditions: "",
    terms_and_conditions_description: {},
}

export const getEmptyMotivators = () => {
    return { ...empty };
}

export const useGetMotivators = () => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } = await api.get(`/motivators/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['motivators'], queryFn: fetchData, enabled: true });
};

export const useUpdateMotivators = (motivatorsId) => {
    const vendorId = useGetVendorId();
    //const queryClient = useQueryClient();
    const updateData = async ({ data: updateData, message = null }) => {
        const { data } = await api.post(`/motivators/${motivatorsId}/?vendorId=${vendorId}`, updateData)
        success(message);
        return data;
    };
    return useMutation(updateData, {
        onSuccess: (data) => {
            //queryClient.invalidateQueries(['questions', moduleId]);
        },
    })
};

export const useInsertMotivators = () => {
    const vendorId = useGetVendorId();
    const queryClient = useQueryClient()
    const insertData = async ({ data: insertData, message = null }) => {
        const { data } = await api.post(`/motivators/?vendorId=${vendorId}`, insertData);
        queryClient.invalidateQueries(['motivators']);
        success(message);
        return data;
    };

    return useMutation(insertData);
};

export const useDeleteMotivators = () => {
    const queryClient = useQueryClient()
    const vendorId = useGetVendorId();
    const deleteQuestion = async ({ data: motivatorsId, message = null }) => {
        await api.delete(`/motivators/${motivatorsId}?vendorId=${vendorId}`);
        queryClient.invalidateQueries(['motivators']);
        success(message);
    };

    return useMutation(deleteQuestion);
};




export function useExportMotivatorsParticipants(motivatorId) {
    const vendorId = useGetVendorId()
    const download = async () => {
        try {
            const { data } = await api.get(`/vendors/${vendorId}/motivator/${motivatorId}/download/?vendorId=${vendorId}`).then((response) => {
                FileDownload(response.data, motivatorId);
            })
        } catch (error) {
            console.error("Error during file download", error);
        }
       // return data;
    }
    return download;
}


export function FileDownload(data, motivatorId) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `registered_users_${motivatorId}.csv`);
    document.body.appendChild(link);
    link.click();
}